"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _obj;
var styleOverrides = {
    root: (_obj = {
        width: 42,
        height: 26,
        padding: 0
    }, _define_property(_obj, "&.".concat(_material.switchClasses.sizeSmall), {
        width: 30,
        height: 20
    }), _define_property(_obj, "&.".concat(_material.switchClasses.sizeSmall, " .").concat(_material.switchClasses.switchBase), _define_property({
        padding: 0
    }, "&.".concat(_material.switchClasses.checked), {
        transform: 'translateX(10px)'
    })), _obj),
    switchBase: function(param) {
        var theme = param.theme;
        var _obj;
        return _obj = {
            padding: 0,
            margin: 2,
            transitionDuration: '300ms'
        }, _define_property(_obj, "&.".concat(_material.switchClasses.checked), _define_property({
            transform: 'translateX(16px)',
            color: theme.palette.common.white
        }, "& + .".concat(_material.switchClasses.track), {
            backgroundColor: theme.palette.default.dark,
            opacity: 1,
            border: 0
        })), _define_property(_obj, "&.Mui-focusVisible .".concat(_material.switchClasses.thumb), {
            color: theme.palette.default.dark,
            border: "6px solid ".concat(theme.palette.common.white)
        }), _define_property(_obj, "&.".concat(_material.switchClasses.disabled, " .").concat(_material.switchClasses.thumb), {
            color: theme.palette.grey[100],
            opacity: 1
        }), _define_property(_obj, "&.".concat(_material.switchClasses.disabled, " + .").concat(_material.switchClasses.track), {
            backgroundColor: theme.palette.grey[200],
            opacity: 1
        }), _obj;
    },
    thumb: {
        boxSizing: 'border-box',
        width: 22,
        height: 22
    },
    track: function(param) {
        var theme = param.theme;
        return {
            borderRadius: 26 / 2,
            backgroundColor: theme.palette.grey[500],
            opacity: 1
        };
    }
};
var defaultProps = {
    focusVisibleClassName: '.Mui-focusVisible',
    disableRipple: true
};
var _default = exports.default = {
    defaultProps: defaultProps,
    styleOverrides: styleOverrides
}; //# sourceMappingURL=MuiSwitch.js.map
